import React from "react";
import PageLayout from "../components/pageLayout";
import HtmlContent, { PhotoLink } from "../components/HtmlContent";
import { mediaUrl, sectionBlocks, useSiteData } from "../lib/siteApi";
import aboutCeremony from "../assets/images/about-ceremony.png";
import { CompanyExtras } from "../components/extraBlocks";

export default function AboutPage() {
  const site = useSiteData();
  const blocks = sectionBlocks(site.content, "about");
  const values = sectionBlocks(site.content, "values");
  const main = blocks[0] || {};
  const rest = blocks.slice(1);

  return (
    <PageLayout
      eyebrow="Who we are"
      title={main.title || "Leading green energy innovators in Rwanda"}
      summary={main.body}
      image={aboutCeremony}
      roomy
    >
      {rest.map((block) => (
        <article key={block.id} className="mb-10 max-w-4xl rounded-3xl bg-white p-8 shadow-lg">
          {block.imageUrl ? <PhotoLink to="/about" src={mediaUrl(block.imageUrl)} alt={block.title || "About"} className="mb-6 w-full rounded-2xl object-cover max-h-80" wrapClassName="rounded-2xl mb-6" /> : null}
          {block.title ? <h2 className="renerg-h3 text-slate-900">{block.title}</h2> : null}
          <div className="renerg-body mt-4 text-slate-600"><HtmlContent html={block.body} imageTo="/about" /></div>
        </article>
      ))}
      {values.length > 0 && (
        <div className="grid gap-6 lg:grid-cols-3">
          {values.map((block) => (
            <article key={block.id} className="rounded-3xl bg-white p-7 shadow-lg">
              {block.imageUrl ? <img src={mediaUrl(block.imageUrl)} alt="" className="mb-4 h-40 w-full rounded-2xl object-cover" /> : null}
              <h2 className="renerg-h4 text-slate-900">{block.title}</h2>
              <div className="mt-3 text-slate-600"><HtmlContent html={block.body} imageTo="/about" /></div>
            </article>
          ))}
        </div>
      )}
      <CompanyExtras />
    </PageLayout>
  );
}
